import { Box, Flex, Skeleton } from '@chakra-ui/react';

import {
  PLAN_HEADER_HORIZONTAL_PADDING,
  PLAN_CHART_CARD_RADIUS,
  PLAN_REVAMP_RADIUS_SM,
  PLAN_TABLE_CELL_BORDER,
  controlHeight,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';

import colors from './dataTheme';

const SourcesTableSkeleton = () => {
  return (
    <Box px={PLAN_HEADER_HORIZONTAL_PADDING} pb={3} w='100%'>
      <Box
        bg={colors.surface}
        border='1px solid'
        borderColor={colors.border}
        borderRadius={PLAN_CHART_CARD_RADIUS}
        overflow='hidden'
      >
        <Flex p={4} gap={3}>
          <Skeleton flex={1} h={controlHeight} borderRadius={PLAN_REVAMP_RADIUS_SM} />
          <Skeleton w='150px' h={controlHeight} borderRadius={PLAN_REVAMP_RADIUS_SM} />
          <Skeleton w='170px' h={controlHeight} borderRadius={PLAN_REVAMP_RADIUS_SM} />
        </Flex>
        {[0, 1, 2, 3, 4].map((row) => (
          <Flex
            key={row}
            px={3}
            py='10px'
            gap={3}
            alignItems='center'
            borderTop='1px solid'
            borderColor={PLAN_TABLE_CELL_BORDER}
          >
            <Skeleton w='40px' h={controlHeight} borderRadius={PLAN_REVAMP_RADIUS_SM} />
            <Skeleton h='14px' w='30%' />
            <Skeleton h='14px' w='10%' ml='auto' />
            <Skeleton h='14px' w='10%' />
          </Flex>
        ))}
      </Box>
    </Box>
  );
};

export default SourcesTableSkeleton;
